<template>
  <div class="app-frame" :class="{ 'app-frame--workspace': showChrome }">
    <AppChrome v-if="showChrome" />
    <div id="workspace-content" class="app-stage" tabindex="-1">
      <router-view />
    </div>
  </div>
</template>

<script>
import AppChrome from './components/AppChrome.vue'

export default {
  name: 'App',
  components: {
    AppChrome
  },
  computed: {
    showChrome() {
      return this.$route.meta.shell === true
    }
  }
}
</script>
